// extracted by mini-css-extract-plugin
export default {"drawer-banner-container":"ogD45lZKnY3Xszxl3TA7","banner-image":"mbRQc3eFGIbkZTCASiUB"};